import { ANSWER } from './schema/answer'
import { CAREER } from './schema/career'
import { FORM } from './schema/form'
import { INTEGRATION } from './schema/integration'
import { PARTNER } from './schema/partner'
import { PAYMENT, PAYMENT_WITH_PLAN } from './schema/payment'
import { PERSON } from './schema/person'
import { SPACE } from './schema/space'
import { SYSTEM } from './schema/system'
import { CAREER_USAGE, PARTNER_AUTOMATIONS, SPACE_USAGE } from './schema/usage'
import { USER } from './schema/user'

export const listPartners = /* GraphQL */ `
  query ListPartners(
    $filter: ModelPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPartners(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items ${PARTNER}
      nextToken
    }
  }
`

// Sparser GSI auf Log: nur ASSISTANT_QUESTION-Zeilen setzen question_log_marker,
// der Index enthaelt deshalb praktisch nur diese — unabhaengig davon, wie
// gross die restliche Log-Tabelle waechst. `data` ist AWSJSON und kommt als
// String zurueck (JSON.parse vor der Auswertung noetig).
export const assistantQuestionsLog = /* GraphQL */ `
  query AssistantQuestionsLog(
    $question_log_marker: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    assistantQuestionsLog(
      question_log_marker: $question_log_marker
      createdAt: $createdAt
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        partner_id
        createdAt
        data
      }
      nextToken
    }
  }
`

export const listUsageCounters = /* GraphQL */ `
  query ListUsageCounters(
    $filter: ModelUsageCounterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsageCounters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        partner_id
        metric
        period
        count
      }
      nextToken
    }
  }
`

export const getSystem = /* GraphQL */ `
  query GetSystem($id: ID!) {
    getSystem(id: $id) ${SYSTEM}
  }
`

export const partnerControl = /* GraphQL */ `
  query PartnerControl(
    $action: String!
    $partner_id: ID
    $aivy_form_id: ID
    $email: String
    $language: String
    $href: String
  ) {
    partnerControl(
      action: $action
      partner_id: $partner_id
      aivy_form_id: $aivy_form_id
      email: $email
      language: $language
      href: $href
    )
  }
`

export const getPartner = /* GraphQL */ `
  query GetPartner($id: ID!) {
    getPartner(id: $id) ${PARTNER}
  }
`

export const paymentByPartnerIdByCreatedAt = /* GraphQL */ `
  query PaymentByPartnerIdByCreatedAt(
    $partner_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentByPartnerIdByCreatedAt(
      partner_id: $partner_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${PAYMENT}
      nextToken
    }
  }
`

export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) ${PAYMENT}
  }
`

export const getForm = /* GraphQL */ `
  query GetForm($id: ID!) {
    getForm(id: $id) ${FORM}
  }
`

export const listForms = /* GraphQL */ `
  query ListForms(
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items ${FORM}
      nextToken
    }
  }
`

export const getSpace = /* GraphQL */ `
  query GetSpace($id: ID!) {
    getSpace(id: $id) ${SPACE}
  }
`

export const answersByOwner = /* GraphQL */ `
  query AnswersByOwner(
    $owner: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAnswerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    answersByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${ANSWER}
      nextToken
    }
  }
`

export const spacesByOwner = /* GraphQL */ `
  query SpacesByOwner(
    $owner: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spacesByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${SPACE}
      nextToken
    }
  }
`

export const spacesByPartnerUserIDByPartner = /* GraphQL */ `
  query SpacesByPartnerUserIDByPartner(
    $partner_user_id: String!
    $partner_id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spacesByPartnerUserIDByPartner(
      partner_user_id: $partner_user_id
      partner_id: $partner_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${SPACE}
      nextToken
    }
  }
`

export const careerByPartnerByDate = /* GraphQL */ `
  query CareerByPartnerByDate(
    $partner_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careerByPartnerByDate(
      partner_id: $partner_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${CAREER}
      nextToken
      __typename
    }
  }
`

export const getCareer = /* GraphQL */ `
  query GetCareer($id: ID!) {
    getCareer(id: $id) ${CAREER}
  }
`

export const careerAnalyseByCareer = /* GraphQL */ `
  query CareerAnalyseByCareer(
    $career_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCareerAnalyseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careerAnalyseByCareer(
      career_id: $career_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        input
        diagnostic_version
        preset
        time_needed
        verified
        status
        career_id
        partner_id
        language
        person_id
        person {
          authorized
          id
          owner
          language
          invitation_firstname
          firstname
          invitation_lastname
          lastname
          invitation_email
          phone
          postcode
          city
          email
          createdAt
          updatedAt
          lastUpdatedBy
          partner_id
          authorized_create
          authorized_read
          authorized_update
          authorized_delete
          personSpaceId
          __typename
        }
        url_params
        invited_from_user_id
        total_time_needed_in_min
        comment {
          person_id
          owner
          message
          createdAt
          __typename
        }
        createdAt
        updatedAt
        lastUpdatedBy
        copy_from_careeranalyse_id
        copy_from_careeranalyse_career_id
        authorized_create
        authorized_read
        authorized_update
        authorized_delete
        __typename
      }
      nextToken
      __typename
    }
  }
`

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) ${USER}
  }
`

export const getPerson = /* GraphQL */ `
  query GetPerson($id: ID!) {
    getPerson(id: $id) ${PERSON}
  }
`

export const listIntegrations = /* GraphQL */ `
  query ListIntegrations(
    $filter: ModelIntegrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items ${INTEGRATION}
      nextToken
      __typename
    }
  }
`

export const integrationControl = /* GraphQL */ `
  query IntegrationControl(
    $action: String!
    $user_id: ID
    $space_id: ID
    $partner_id: ID
  ) {
    integrationControl(
      action: $action
      user_id: $user_id
      space_id: $space_id
      partner_id: $partner_id
    )
  }
`

export const spacesByPartnerIdByUpdatedAt = /* GraphQL */ `
  query SpacesByPartnerIdByUpdatedAt(
    $partner_id: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spacesByPartnerIdByUpdatedAt(
      partner_id: $partner_id
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${SPACE}
      nextToken
    }
  }
`

export const spacesByCareerId = /* GraphQL */ `
  query SpacesByCareerId(
    $career_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spacesByCareerId(
      career_id: $career_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        authorized
        partner_id
        career_id
        created_by_partner_id
        authorized_create
        authorized_read
        authorized_update
        authorized_delete
        application_status
        language
        context
        os
        invitation_via
        progress
        mail_stored
        all_challenges_unlocked
        newsletter
        ref_link
        referrer_link
        matching_score_to_space_career
        related_spaces
        partner_user_id
        invited_from_user_id
        favored_by_user_id
        invitation_id
        callback_url
        expiresAt
        created_with_service
        invitation_reminder_at
        reset_expiredAt_at
        additional_requested_data
        diagnostic_version
        is_demo
        universal_app_meta
        customer_dashboard_meta
        authorization_roles
        soft_deleted
        last_seen
        lastUpdatedBy
        createdAt
        updatedAt
        person {
          id
          owner
          authorized
          language
          invitation_firstname
          firstname
          invitation_lastname
          lastname
          invitation_email
          email
          phone
          postcode
          city
          partner_id
          authorized_create
          authorized_read
          authorized_update
          authorized_delete
          lastUpdatedBy
          personSpaceId
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`

export const listAnalyticsEvents = /* GraphQL */ `
  query ListAnalyticsEvents($filter: AWSJSON) {
    listAnalyticsEvents(filter: $filter)
  }
`

// ---------------------------------------------------------------------------
// Pricing (Pakete, Nutzung). query() in src/api/index.js liest das Ergebnis
// unter data[<Exportname>]. Neue Namen sind deshalb Aliase auf die
// bestehenden Root-Felder. Die Varianten mit WithPlan laufen nur, wenn die
// Schema-Probe (src/api/capabilities.js) Payment.plan meldet.
// ---------------------------------------------------------------------------

export const getPaymentWithPlan = /* GraphQL */ `
  query GetPaymentWithPlan($id: ID!) {
    getPaymentWithPlan: getPayment(id: $id) ${PAYMENT_WITH_PLAN}
  }
`

export const paymentByPartnerIdByCreatedAtWithPlan = /* GraphQL */ `
  query PaymentByPartnerIdByCreatedAtWithPlan(
    $partner_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentByPartnerIdByCreatedAtWithPlan: paymentByPartnerIdByCreatedAt(
      partner_id: $partner_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${PAYMENT_WITH_PLAN}
      nextToken
    }
  }
`

export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items ${PAYMENT}
      nextToken
    }
  }
`

export const listPaymentsWithPlan = /* GraphQL */ `
  query ListPaymentsWithPlan(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsWithPlan: listPayments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${PAYMENT_WITH_PLAN}
      nextToken
    }
  }
`

// Stellen für das Stellen-Limit, wie careerUsageByPartnerByDate im Dashboard
export const careerUsageByPartnerByDate = /* GraphQL */ `
  query CareerUsageByPartnerByDate(
    $partner_id: ID!
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careerUsageByPartnerByDate: careerByPartnerByDate(
      partner_id: $partner_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${CAREER_USAGE}
      nextToken
    }
  }
`

// Talente und Zugänge in einem Durchgang über die Space-Partition des
// Partners (Filter auf SELECT, TALENTPOOL, ATTRACT und EMPLOYEE). Der Index
// liest die Partition ohnehin ganz, ein zweiter Query hieße einen zweiten
// vollen Durchgang. Aufgeteilt wird clientseitig nach context.
export const spaceUsageByPartner = /* GraphQL */ `
  query SpaceUsageByPartner(
    $partner_id: ID!
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spaceUsageByPartner: spacesByPartnerIdByUpdatedAt(
      partner_id: $partner_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${SPACE_USAGE}
      nextToken
    }
  }
`

// DSGVO-Automatisierung des Partners für die Warnung auf der Payment-Seite
export const getPartnerAutomations = /* GraphQL */ `
  query GetPartnerAutomations($id: ID!) {
    getPartnerAutomations: getPartner(id: $id) ${PARTNER_AUTOMATIONS}
  }
`
